import {
  Button,
  CardHeader,
  CardActions,
  useTheme,
  useMediaQuery,
  Grid,
  CardMedia,
} from "@mui/material";
import React from "react";
import {
  CustomCard,
  CustomCardMedia,
  CustomZoomImage,
} from "./common-components";
import PopUp from "./PopUp";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";

export default function VideoCard(props) {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [open, setOpen] = React.useState(false);
  const [tutorial, setTutorial] = React.useState(true);

  const changeStep = () => {
    setTutorial(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let popUp = <PopUp
    open={open}
    handleClose={handleClose}
    handleAlert={props.handleAlert}
    faceDetection={props.faceDetection}
    cardDetection={props.cardDetection}
    onTakingImage={props.setImageData}
    popUpTitle={props.popUpTitle}
    tutorialOpen={tutorial}
    tutorialChangeStep={changeStep}
    tutorialTitle={props.tutorialTitle}
    tutorialContent={props.tutorialContent}
  />

  if (smallScreen) {
    return (
      <CustomCard>
        <CardHeader title={props.title} />
        {props.imageData ? (
          <CustomCardMedia
            component="img"
            src={props.imageData}
            alt={props.imageData ? "Ảnh khuôn mặt" : null}
          />
        ) : (
          <CardMedia
            component="img"
            src="/place_holder.png"
            alt="http://www.onlinewebfonts.com"
            sx={{
              margin: "auto",
              width: "auto",
              maxWidth: "100%",
              maxHeight: "15vh",
              opacity: 0.2,
              padding: "1em",
            }}
          />
        )}
        <CardActions>
          <Button
            variant="contained"
            component="span"
            onClick={handleClickOpen}
            disabled={props.disabled}
            sx={{ marginLeft: "auto", marginRight: "auto" }}
          >
            Mở Camera
          </Button>
          {popUp}
        </CardActions>
      </CustomCard>
    );
  } else {
    return (
      <CustomCard>
        <Grid container>
          <Grid
            item
            lg={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "auto",
              justifyContent: "space-between",
            }}
          >
            <CardHeader title={props.title} />
            <CardActions>
              <Button
                variant="contained"
                component="span"
                onClick={handleClickOpen}
                disabled={props.disabled}
              >
                Mở Camera
              </Button>
              {popUp}
            </CardActions>
          </Grid>
          <Grid item lg={8} sx={{ display: "flex", minHeight: "29.35vh" }}>
            {props.imageData ? (
              <CustomZoomImage
                src={props.imageData}
                zoomScale={1}
                zoomType="hover"
                fadeDuration={0}
                hideHint={true}
              />
            ) : (
              <CardMedia
                component="img"
                src="/place_holder.png"
                alt="http://www.onlinewebfonts.com"
                sx={{
                  margin: "auto",
                  width: "auto",
                  maxWidth: "100%",
                  maxHeight: "15vh",
                  opacity: 0.2,
                }}
              />
            )}
          </Grid>
        </Grid>
      </CustomCard>
    );
  }
}
